import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CountdownService {
  private readonly _countdown = signal(0);
  readonly countdown = this._countdown.asReadonly();

  private timerId: ReturnType<typeof setTimeout> | null = null;

  startCountdown(seconds: number): void {
    this.stopCountdown();

    this._countdown.set(seconds);

    const tick = (): void => {
      const value = this._countdown();

      if (value <= 0) {
        this.stopCountdown();
        return;
      }

      this.timerId = setTimeout(() => {
        this._countdown.set(value - 1);
        tick();
      }, 1000);
    };

    tick();
  }

  stopCountdown(): void {
    if (this.timerId !== null) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }

  resetCountdown(): void {
    this.stopCountdown();
    this._countdown.set(0);
  }
}
